@if (visible$ | async) {
<div class="add-to-cart">
  <button
    type="submit"
    name="addProduct"
    class="btn"
    [ngClass]="cssClass()"
    [class.btn-primary]="!displayPlainText && !displayIcon"
    [disabled]="(buttonDisabled$ | async) || addToCartButton()"
    [title]="displayIcon ? (translationKey$ | async | translate) : ''"
    [tabindex]="ariaHidden() ? -1 : 0"
    [attr.aria-hidden]="ariaHidden()"
    (click)="addToBasket()"
    data-testing-id="addToCartButton"
  >
    @if ((displaySpinner$ | async) !== true) {
    <!-- Add to Cart button -->
    @if (displayIcon) {
    <fa-icon [icon]="['fas', 'shopping-cart']" />
    } @else {
    {{ translationKey$ | async | translate }}
    } } @else {
    <fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" [ngClass]="{ 'pr-3': !displayIcon }" />
    @if (!displayIcon) {
    <span>{{ 'common.button.spinning.label' | translate }}</span>
    } }
    <!-- button with spinning animation after Add to Cart -->
  </button>
</div>
}
